// @flow

import React from 'react'
import upIcon from '../../Icons/icon-up.svg'
import downIcon from '../../Icons/icon-down.svg'
import neutralIcon from '../../Icons/icon-neutral.svg'
import Loading from '../../Icons/loading.gif'
import PieChart from 'michelangelo/dist/WebComponents/Charts/PieChart'
import Row from 'michelangelo/dist/Components/Row'
import Column from 'michelangelo/dist/Components/Column'

type Props = {
  loading: boolean,
  totalRegisteredPercent: number,
  newRegistrations: number,
  sinceText: string,
  totalUsers: number,
  registeredUsers: number,
  totalLicenses: number
}

const userBgColors = ['#0ABD63', '#F07B7B']
const userLabels = ['Registered', 'Not Registered']
const options = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      display: false
    }
  }
}

function IndividualBlock ({
  loading,
  totalRegisteredPercent,
  newRegistrations,
  sinceText,
  totalUsers,
  registeredUsers,
  totalLicenses
}: Props) {
  const emptyNewRegistrations = newRegistrations === null || newRegistrations === undefined
  const newRegistrationsFormatted = !emptyNewRegistrations
    ? newRegistrations.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : ''

  const LoadingIndicator = () => (<div><img src={Loading} alt='Loading' /></div>)

  const formatTotal = (num) => {
    if (num > 999) return parseFloat(num / 1000) + 'K'
    else if (num > 999999) return parseFloat(num / 1000000) + 'M'
    return num
  }

  return (
    <div className='BlockItem' style={{ flexBasis: '70%', flexGrow: 0 }}>
      <h4>Individual</h4>
      {loading && <LoadingIndicator />}
      {!loading && (
        <Row>
          <Column classNames={['is-4 is-4-desktop']}>
            <div className='BlockHeaderWrapper'>
              <h1> {Math.round(totalRegisteredPercent * 100)}% </h1>
              <h5 className='BlockSubHeader'> Total Registered </h5>
            </div>
            {emptyNewRegistrations || newRegistrations === 0
              ? <p><img src={neutralIcon} alt='Neutral' /> No new registration(s) {sinceText}</p>
              : newRegistrations > 0
                ? <p><img src={upIcon} alt='Up' /> {newRegistrationsFormatted} New registration(s) {sinceText}</p>
                : <p><img src={downIcon} alt='Down' /> {newRegistrationsFormatted} New registration(s) {sinceText}</p>}
          </Column>
          <Column classNames={['is-1 is-1-desktop']}>
            <div className='divider' />
          </Column>
          <Column classNames={['is-4 is-4-desktop']}>
            <Row>
              <Column classNames={['is-12 is-12-desktop']}>
                <Row>
                  <Column classNames={['is-3 is-3-desktop']}>
                    <div className='ChartItemNumber'>{formatTotal(totalUsers)} </div>
                  </Column>
                  <Column classNames={['is-9 is-9-desktop']}>
                    <div className='ChartItemText'>TOTAL USERS</div>
                  </Column>
                </Row>
                <Row>
                  <Column classNames={['is-3 is-3-desktop']}>
                    <div className='ChartItemNumber'>{formatTotal(registeredUsers)} </div>
                  </Column>
                  <Column classNames={['is-9 is-9-desktop']}>
                    <div className='ChartItemText'>REGISTERED USERS</div>
                  </Column>
                </Row>
                <Row>
                  <Column classNames={['is-3 is-3-desktop']}>
                    <div className='ChartItemNumber'>{formatTotal(totalUsers - registeredUsers)} </div>
                  </Column>
                  <Column classNames={['is-9 is-9-desktop']}>
                    <div className='ChartItemText'>UNREGISTERED USERS</div>
                  </Column>
                </Row>
                <Row>
                  <Column classNames={['is-3 is-3-desktop']}>
                    <div className='ChartItemNumber'>{formatTotal(totalLicenses)} </div>
                  </Column>
                  <Column classNames={['is-9 is-9-desktop']}>
                    <div className='ChartItemText'>LICENCE LIMIT</div>
                  </Column>
                </Row>
              </Column>
            </Row>
          </Column>
          <Column classNames={['is-3 is-3-desktop']}>
            <PieChart
              chartId='DashboardChart'
              data={[registeredUsers, totalUsers - registeredUsers]}
              labels={userLabels}
              colors={userBgColors}
              options={options}
              height={200} />
          </Column>
        </Row>
      )}
    </div>
  )
}

export default IndividualBlock
